import { render, staticRenderFns } from "./ApplicationUpdateForm.vue?vue&type=template&id=70d59313&"
import script from "./ApplicationUpdateForm.vue?vue&type=script&lang=js&"
export * from "./ApplicationUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports